import React, { useEffect, useState } from "react";
import table_arrow from "../../assets/images/small_arrow_down.png";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../api/api";
import moment from "moment";
import constants from "../../utils/contants";
import Processing from "../processing/processing";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { Pagination } from "react-bootstrap/esm";
import AddDriverModal from "../addDriverModal/AddDriverModal";

const DriverTable = ({ search, status }) => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [body, setBody] = useState({
    is_send_request: ""
  })

  const [errorMsg, setErrorMsg] = useState('')

  const navigate = useNavigate();
  const [totalDriver, setTotalDriver] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [listTotal, setListTotal] = useState(10);
  const [show, setShow] = useState(false);
  const [deleteId, setDeleteId] = useState();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const totalPages = Math.ceil(totalDriver / listTotal)

  useEffect(() => {
    getAllDrivers(activePage, listTotal)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listTotal]);

  useEffect(() => {
    getAllDrivers(activePage, listTotal);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllDrivers = (page, listTotal) => {
    setLoading(true);
    // console.log("token: ", localStorage.getItem(constants.TOKEN))
    API(`get-all-drivers?page=${page}&size=${listTotal}`, "get", "", localStorage.getItem(constants.TOKEN))
      .then((response) => {
        setLoading(false);
        setErrorMsg("")
        setTotalDriver(response?.totalDrivers)
        console.log(response.data);
        setDrivers(response?.data);
      })
      .catch((error) => {
        setLoading(false);
        setErrorMsg("Something went wrong!")
        console.log("error: ", JSON.stringify(error?.response?.data));
      });
  }

  let innerPElem = <p className='text-center mb-sm-0 cursor-pointer page-link'>...</p>

  const handlePageClick = (pageNumber) => {
    setActivePage(pageNumber)
    getAllDrivers(pageNumber, listTotal);
  }
  const getPaginationItems = () => {
    const paginationItems = []

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages + 1 || Math.abs(i - activePage) <= 2) {
        paginationItems.push(
          <Pagination.Item key={i} onClick={() => handlePageClick(i)} active={i === activePage}>
            {i}
          </Pagination.Item>
        )
      } else if (paginationItems[paginationItems.length - 1] !== innerPElem) {
        paginationItems.push(innerPElem)
      }
    }

    return paginationItems
  }

  const onDelete = () => {
    handleClose();
    // console.log("token and id: ",localStorage.getItem(constants.TOKEN), " ", deleteId)
    // setLoading(true);
    console.log("delete id: ", deleteId)
    API(`delete-driver/${deleteId}`, "get", "", localStorage.getItem(constants.TOKEN))
      .then((res) => {
        setLoading(false);
        // console.log("res: ", res);
        toast.success("Driver Deleted successfully ✅", {
          position: toast.POSITION.TOP_RIGHT,
          className: "bg-success text-white",
        });
        getAllDrivers(activePage, listTotal);
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error while Deleting Driver", {
          position: toast.POSITION.TOP_RIGHT,
        });
        console.log("error: ", error);
      });
  };
  const updateStatus = (e, id) => {
    console.log("User Selected Value - ", e.target.value)
    if (e.target.value === "Approved") {
      setBody({
        is_send_request: e.target.value,
        is_verified_driver: true
      })
    } else {
      setBody({
        is_send_request: e.target.value,
        is_verified_driver: false
      })
    }
    API(`update-driver/${id}`, "put", body, localStorage.getItem(constants.TOKEN))
      .then((res) => {
        console.log("res: ", res);
        toast.success("Driver Details updated successfully ✅", {
          position: toast.POSITION.TOP_RIGHT,
          className: "bg-success text-white",
        });
        getAllDrivers(activePage, listTotal);
        // navigate("/manage-driver");
      })
      .catch((error) => {
        toast.error("Error while updating Driver Details", {
          position: toast.POSITION.TOP_RIGHT,
        });
        console.log("error: ", error);
      });
  }

  const handleNext = () => {
    if (activePage !== totalPages) {
      setActivePage((prev) => prev + 1);
      getAllDrivers(activePage + 1, listTotal)
    }
  };
  const handlePrev = () => {
    if (activePage !== 1) {
      setActivePage((prev) => prev - 1);
      getAllDrivers(activePage - 1, listTotal)
    }
  };

  const byCategory = (drivers, status) => {
    if (status) {
      return drivers.is_send_request === status;
    } else return drivers;
  };

  const bySearch = (drivers, search) => {
    if (search) {
      return drivers.firstname.toLowerCase().includes(search.toLowerCase());
    } else return drivers;
  };

  const filteredList = (drivers, search) => {
    return drivers
      .filter(drivers => byCategory(drivers, status))
      .filter(drivers => bySearch(drivers, search));
  };



  return (
    <>
      <div className="ta__usertable">
        <div className="ta__table_nav d-flex flex-column flex-sm-row mb-4 justify-content-between align-items-center">
          <div className="ta__table_entries d-flex align-items-center mb-3 mb-lg-0">
            <span className="f-18"> Show </span>
            <div className="ta__country_dropdown entries_select">
              <select className="" name="showEntry" onChange={(e) => setListTotal(Number(e.target.value))}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
              </select>
            </div>
            <span className="f-18">Entries </span>
          </div>
          <button
            className='btn btn_primary px-2'
            data-bs-toggle="modal"
            data-bs-target="#addAdviceModal"
          >
            Add Driver
          </button>
          <AddDriverModal />
        </div>
        <div className="table_container">
          <table className="drivarTabel" id="driverTable">
            <thead>
              <tr key={"header"}>
                <th width="140px">
                  <Link to="#">
                    Full name <img src={table_arrow} alt="arrow" />
                  </Link>
                </th>
                <th>
                  <Link to="#">
                    Phone <img src={table_arrow} alt="arrow" />
                  </Link>
                </th>
                <th>
                  <Link to="#">
                    Vehicle <img src={table_arrow} alt="arrow" />
                  </Link>
                </th>
                <th>
                  <Link to="#">
                    Register Date <img src={table_arrow} alt="arrow" />
                  </Link>
                </th>
                <th>
                  <Link to="#">
                    Status <img src={table_arrow} alt="arrow" />
                  </Link>
                </th>
                <th>
                  <Link to="#">
                    Activity <img src={table_arrow} alt="arrow" />
                  </Link>
                </th>
                <th>
                  <Link to="#">
                    Location <img src={table_arrow} alt="arrow" />
                  </Link>
                </th>
                <th>
                  <Link to="#">
                    Actions <img src={table_arrow} alt="arrow" />
                  </Link>
                </th>
              </tr>
            </thead>

            <tbody>
              {filteredList(drivers, search).map((driver, index) => (
                <tr key={driver?._id}>
                  <td data-label="Full name">
                    {driver?.firstname + " " + driver?.lastname}
                  </td>
                  <td data-label="Phone">{driver?.phone_no}</td>
                  <td data-label="Vehicle">{driver?.car_info?.car_type?.name || "-"}</td>
                  <td data-label="Creates">
                    {moment(driver?.createdAt).format(
                      "DD MMM YYYY HH:MM"
                    )}
                  </td>
                  <td data-label="Status">
                    <select
                      name="status"
                      id=""
                      onChange={(e) => {
                        updateStatus(e, driver?._id);
                      }}
                      defaultValue={driver?.is_send_request}
                    >
                      <option value="Approved">Approved</option>
                      <option value="Rejected">Rejected</option>
                      <option value="Requested">Requested</option>
                      <option value="Pending">Pending</option>
                    </select>
                  </td>
                  <td data-label="Active">{
                    (driver?.location?.isOnline === true) ? <span className='btn btn-success active_btn'> Active </span> : <span className='btn btn-danger active_btn'> Inactive </span>
                  }</td>
                  {/* <td data-label="Training Planned">-</td> */}
                  <td data-label="Location">
                    {(driver && driver?.location) ?
                      <a
                        className=""
                        target="_blank"
                        rel="noreferrer"
                        href={`https://www.google.com/maps/search/?q=${driver?.location?.latitude},${driver?.location?.longtitude}`}
                      >
                        Last location
                      </a> : "-"}
                  </td>
                  <td data-label="Actions" className="d-lg-flex justify-content-lg-center">
                    <button
                      className='btn btn-dark p-1 me-2'
                      onClick={() =>
                        navigate(`/manage-driver/${driver?._id}`, {
                          state: { driver: driver },
                        })
                      }
                    >
                      <svg width="25" height="25" viewBox="0 0 92 92" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M72.7873 7.71265L84.2873 19.2126L75.5205 27.9833L64.0205 16.4833L72.7873 7.71265ZM30.6666 61.3333H42.1666L70.1001 33.3998L58.6001 21.8998L30.6666 49.8333V61.3333Z" fill="#fff" />
                        <path d="M72.8333 72.8333H31.2723C31.1727 72.8333 31.0692 72.8717 30.9695 72.8717C30.843 72.8717 30.7165 72.8372 30.5862 72.8333H19.1667V19.1667H45.4135L53.0802 11.5H19.1667C14.9385 11.5 11.5 14.9347 11.5 19.1667V72.8333C11.5 77.0653 14.9385 80.5 19.1667 80.5H72.8333C74.8667 80.5 76.8167 79.6923 78.2545 78.2545C79.6923 76.8167 80.5 74.8667 80.5 72.8333V39.606L72.8333 47.2727V72.8333Z" fill="#fff" />
                      </svg>
                    </button>

                    <button
                      className='btn btn-danger p-1'
                      onClick={() => {
                        setDeleteId(driver?._id);
                        handleShow();
                      }}>
                      <svg width="25" height="25" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2448_1118)">
                          <path d="M17.85 2.5C18.3747 2.50014 18.8861 2.66536 19.3116 2.97226C19.7372 3.27916 20.0554 3.71219 20.2213 4.21L20.9 6.25H25C25.3315 6.25 25.6495 6.3817 25.8839 6.61612C26.1183 6.85054 26.25 7.16848 26.25 7.5C26.25 7.83152 26.1183 8.14946 25.8839 8.38388C25.6495 8.6183 25.3315 8.75 25 8.75L24.9962 8.83875L23.9125 24.0175C23.8449 24.9633 23.4215 25.8483 22.7275 26.4944C22.0336 27.1406 21.1207 27.4999 20.1725 27.5H9.8275C8.87932 27.4999 7.96638 27.1406 7.27246 26.4944C6.57853 25.8483 6.15514 24.9633 6.0875 24.0175L5.00375 8.8375C5.00149 8.80839 5.00024 8.7792 5 8.75C4.66848 8.75 4.35054 8.6183 4.11612 8.38388C3.8817 8.14946 3.75 7.83152 3.75 7.5C3.75 7.16848 3.8817 6.85054 4.11612 6.61612C4.35054 6.3817 4.66848 6.25 5 6.25H9.1L9.77875 4.21C9.94462 3.71199 10.263 3.27881 10.6889 2.97189C11.1147 2.66497 11.6263 2.49987 12.1512 2.5H17.85ZM22.4962 8.75H7.50375L8.58125 23.8387C8.60369 24.154 8.74472 24.4491 8.97595 24.6645C9.20718 24.88 9.51145 24.9998 9.8275 25H20.1725C20.4886 24.9998 20.7928 24.88 21.0241 24.6645C21.2553 24.4491 21.3963 24.154 21.4188 23.8387L22.4962 8.75ZM12.5 12.5C12.8062 12.5 13.1017 12.6124 13.3305 12.8159C13.5593 13.0193 13.7054 13.2997 13.7413 13.6038L13.75 13.75V20C13.7496 20.3186 13.6277 20.625 13.4089 20.8567C13.1902 21.0884 12.8913 21.2278 12.5733 21.2465C12.2552 21.2651 11.942 21.1617 11.6977 20.9572C11.4534 20.7527 11.2964 20.4626 11.2587 20.1463L11.25 20V13.75C11.25 13.4185 11.3817 13.1005 11.6161 12.8661C11.8505 12.6317 12.1685 12.5 12.5 12.5ZM17.5 12.5C17.8315 12.5 18.1495 12.6317 18.3839 12.8661C18.6183 13.1005 18.75 13.4185 18.75 13.75V20C18.75 20.3315 18.6183 20.6495 18.3839 20.8839C18.1495 21.1183 17.8315 21.25 17.5 21.25C17.1685 21.25 16.8505 21.1183 16.6161 20.8839C16.3817 20.6495 16.25 20.3315 16.25 20V13.75C16.25 13.4185 16.3817 13.1005 16.6161 12.8661C16.8505 12.6317 17.1685 12.5 17.5 12.5ZM17.85 5H12.15L11.7338 6.25H18.2662L17.85 5Z" fill="#fff" />
                        </g>
                        <defs>
                          <clipPath id="clip0_2448_1118">
                            <rect width="30" height="30" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <h2 className="error_msg text-center"> {errorMsg}  </h2>
          {loading && <Processing />}
        </div>
        <Pagination className='justify-content-end pagination mt-4'>
          <p className='text-center mb-sm-0 cursor-pointer pagination-btn prev' onClick={handlePrev}>
            Previous
          </p>
          {getPaginationItems()}
          <p className='text-center mb-sm-0 cursor-pointer pagination-btn next' onClick={handleNext}>
            Next
          </p>
        </Pagination>
      </div>

      <Modal show={show} centered onHide={handleClose}>
        <Modal.Header
          closeButton
          closeVariant="dark"
          className="primary_bg bg-white border-0 text-black"
        >
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body className="primary_bg bg-white text-black">
          Are you sure you want to delete the User?
        </Modal.Body>
        <Modal.Footer className="primary_bg bg-white border-0">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="danger" onClick={onDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DriverTable;
